import * as React from "react";
import { Context } from "./_context";
export const NavAddIcon = ({ size = 16, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[16] = /* @__PURE__ */ React.createElement("svg", { width: "1rem", height: "1rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9 7h5v2H9v5H7V9H2V7h5V2h2v5Z", fill: "currentColor" }));
  return iconset[size];
};
NavAddIcon.iconId = "MMSx92";
